import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { ProductCreatePage } from "./create_page";
import { ProductDetailPage } from "./detail_page";
import { ProductEditPage } from "./edit_page";
import { ProductListPage } from "./list_page";

export const ProductMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.product} exact>
        <ProductListPage />
      </Route>

      <Route path={Routing.generateCreateRoute(ROUTES.product)}>
        <ProductCreatePage />
      </Route>

      <Route path={Routing.generateEditRoute(ROUTES.product)}>
        <ProductEditPage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.product)}>
        <ProductDetailPage />
      </Route>
    </Switch>
  );
};
